/**
 * Language switcher — visual active state in the pill control.
 *
 * The actual language redirect is handled by Polylang via the link href
 * (rendered server-side). This module only manages the cosmetic active class
 * for instant feedback when the user clicks a language button-link.
 */
export function initLangSwitcher() {
  document.querySelectorAll('.lang').forEach((group) => {
    group.addEventListener('click', (e) => {
      const btn = e.target.closest('.lang__btn');
      if (!btn) return;
      group.querySelectorAll('.lang__btn').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });
}
